module.exports = __webpack_public_path__ + "img/1.7daaa0d0.png";